module.exports = __webpack_public_path__ + "static/media/Robotomedium.4a34361b.woff2";